import { TUserProfile, USER_ROLE } from '@/types/user-profile'
import Service, { getCallApiFunction } from '../service'
export type ParamsType = {
  role?: string
  memberInfoId?: string
  followerType?: USER_ROLE
  followeeType?: USER_ROLE
}

type ResponseType = {
  isSuccess: boolean
  memberInfo: TUserProfile[]
}
class FetchFollowingMembersApi extends Service {
  constructor({ memberInfoId, ...rest }: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/following',
      method: 'GET',
      params: {
        ...rest,
        id: memberInfoId,
      },
    }
  }
}
export const fetchFollowingMembers = async (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new FetchFollowingMembersApi(params))
